import * as Sentry from "@sentry/react";
import { getEnv } from "./utils";

Sentry.init({
  enabled: !["local", "test"].includes(getEnv("VITE_AMPLIFILES_ENV")),
  dsn: "https://518bf292105946cc20092390295f20e8@o4508766873911296.ingest.de.sentry.io/4509468050391120",
  dataCollection: {
    userInfo: false,
    cookies: false,
    httpHeaders: {
      request: { deny: ["forwarded", "-ip", "remote-", "via", "-user"] },
      response: { deny: ["forwarded", "-ip", "remote-", "via", "-user"] },
    },
    httpBodies: [],
    urlQueryParams: { deny: ["forwarded", "-ip", "remote-", "via", "-user"] },
    genAI: { inputs: false, outputs: false },
    databaseQueryData: false,
    queues: false,
    graphQL: { document: false, variables: false },
  },
  integrations: [
    Sentry.captureConsoleIntegration({
      levels: ["error"],
    }),
  ],
  ignoreErrors: [
    "The play() request was interrupted",
    "e.clearFeedback is not a function.",
  ],
  allowUrls: ["amplifiles.ai", "localhost", "127.0.0.1"],
});
